export default "__VITE_ASSET__xt5RflBt__"